module.exports = __webpack_public_path__ + "static/img/plan1.51d3e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/plan1.png
// module id = KX3k
// module chunks = 1